import { render, staticRenderFns } from "./vs-dropdown.vue?vue&type=template&id=47c2b411&scoped=true"
import script from "./vs-dropdown.vue?vue&type=script&lang=js"
export * from "./vs-dropdown.vue?vue&type=script&lang=js"
import style0 from "./vs-dropdown.vue?vue&type=style&index=0&id=47c2b411&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c2b411",
  null
  
)

export default component.exports